import React, { useEffect, useState } from "react";
import "./Foreclosed.css";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { url } from "../../../../../App";
import Cookies from 'js-cookie';

const Foreclosed = ({ loanData }) => {
  const [open, setOpen] = React.useState(false);
  const [forecloseData, setForecloseData] = useState("");
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [base64STR, setBase64STR] = useState("");
  const [showData, setshowData] = useState(false);


  // console.log(loanData);

  useEffect(() => {
    setOpen(true);
    axios
      .post(url + "/loan/foreclosed", {
        email: email,
        token: token,
        loan_id: loanData.loan_id,
      })
      .then((res) => {
        console.log(res);
        setOpen(false);
        if (res.data.auth === true) {
          setForecloseData(res.data.message.forecloseDate);
          setBase64STR(res.data.message.forecloseBase64);
        } else {
          setOpen(false);
          toast.error(res.data.message);
          setshowData(true)
        }
      })
      .catch((err) => {
        setOpen(false);
        // console.log(err);
        toast.error(err.message);
      });
  }, [email, token, loanData.loan_id]);

  return (
    <>
      <div className="foreclosed">
        {showData === true ? (
          <div style={{textAlign:"center",fontSize:"1.3rem"}}>No Data Found</div>
        ) : (
          <div className="foreclosed-table-div">
            <div style={{ margin: "1rem 0" }}>
              <p>
                <strong>Payment Date : {forecloseData.paymentDate?.slice(0, 10)}</strong>
              </p>
            </div>
            <table className="foreclosed-table">
              <thead>
                <tr>
                  <th colSpan="2">Principal Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Loan Amount</td>
                  <td>
                    {parseInt(forecloseData.principalOverdue) + parseInt(forecloseData.principalPaid) + parseInt(forecloseData.principalDue)}
                  </td>
                </tr>
                <tr>
                  <td>Principal Paid</td>
                  <td>{forecloseData.principalPaid}</td>
                </tr>
                <tr>
                  <td>Principal Overdue</td>
                  <td>{forecloseData.principalOverdue}</td>
                </tr>
                <tr>
                  <td>Principal Due</td>
                  <td>{forecloseData.principalDue}</td>
                </tr>
                <tr>
                  <td>Total Principal Pending</td>
                  <td>
                    {parseInt(forecloseData.principalOverdue) + parseInt(forecloseData.principalDue)}
                  </td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th colSpan="2">Interest Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Unpaid + Part Paid EMI Interest</td>
                  <td>{forecloseData.intrestOverdue}</td>
                </tr>
                <tr>
                  <td>Next Due EMI Interest</td>
                  <td>{forecloseData.nextIntrestDue}</td>
                </tr>
                <tr>
                  <td>Roll Over Interest</td>
                  <td>{forecloseData.rollOverIntrestPending}</td>
                </tr>
                <tr>
                  <td>Total Interest Pending</td>
                  <td>{forecloseData.totalIntrest}</td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th colSpan="2">Charge Amount(Excl GST)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Nach Bounce Charges</td>
                  <td>{forecloseData.nachBounceCharge}</td>
                </tr>
                <tr>
                  <td>Late Payment Charges</td>
                  <td>{forecloseData.latePaymentCharge}</td>
                </tr>
                <tr>
                  <td>Foreclosure Charges</td>
                  <td>{forecloseData.forcloseChargesIntrest}</td>
                </tr>
                <tr>
                  <td>Total Charges Pending</td>
                  <td>{forecloseData.totalCharges}</td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th colSpan="2">Foreclosure Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>GST Amount On Charges</td>
                  <td>{forecloseData.gstOnCharge}</td>
                </tr>
                <tr>
                  <td>Waiver Amount</td>
                  <td>{forecloseData.totalWavierAmount}</td>
                </tr>
                <tr>
                  <td>Foreclosure Amount</td>
                  <td>{forecloseData.forCloseAmount}</td>
                </tr>
              </tbody>
            </table>
            <Button
              download="Foreclose Letter"
              href={`data:application/pdf;base64,${base64STR}`}
              variant="contained"
              sx={{ marginTop: "1rem" }}
            >
              Download
            </Button>
          </div>
        )}
        <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default Foreclosed;
